/* 🤖 this file was generated by svg-to-ts */
export const DfIconThumbsDownCircle16: {
  name: 'thumbs-down-circle-16';
  data: string;
} = {
  name: 'thumbs-down-circle-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm2-10.775a1 1 0 0 0-.679-.947l-.509-.172A2 2 0 0 0 8.17 4H5.721a1 1 0 0 0-.949.685l-.67 2.017A2 2 0 0 0 4 7.333v.426c0 .43.316.796.742.857l2.204.307a.5.5 0 0 1 .416.619l-.333 1.303a.966.966 0 0 0 .42 1.057.66.66 0 0 0 .91-.217L9.851 9.25A1 1 0 0 0 10 8.727zM11.5 9a.5.5 0 0 0 .5-.5v-3a.5.5 0 1 0-1 0v3a.5.5 0 0 0 .5.5z" fill-rule="evenodd"/></svg>`
};
